<template>
  <div>
    <div class="teacher-info">
      <div class="base-info">
        <div style="display: flex;align-items: center;margin-bottom: 24rem">
          <el-image :src="jcxx" style="width: 24rem; height: 24rem"></el-image>
          <div style="font-weight: 600;font-size: 24rem;color: #1E3AA2;flex: 1;margin-left: 14rem">基础信息</div>
          <el-image :src="xjList[teacherInfo.star_rating === '无' ? 0 : teacherInfo.star_rating]" style="width: 158rem; height: 36rem"></el-image>
        </div>
        <div class="avatar">
          <el-image :src="teacherInfo.photo==null||teacherInfo.photo ==''?img_:teacherInfo.photo" style="width: 100rem;height: 100rem;border-radius: 100rem;margin-right: 40rem"></el-image>
          <div style="font-weight: 600;font-size: 32rem;color: #2B3541;margin-right: 12rem">{{ teacherInfo.clerk_name }}</div>
          <el-image v-if="teacherInfo.gender === 2" style="width: 24rem; height: 24rem" :src="$OssAddress+'imgs/nan.svg'" :fit="fit"></el-image>
          <el-image v-if="teacherInfo.gender === 1" style="width: 24rem; height: 24rem" :src="$OssAddress+'imgs/nv.svg'" :fit="fit"></el-image>
        </div>
        <div class="info">
          <div class="vitae">
            <div class="row">
              <div class="key">所属校区</div>
              <div class="val" :title="teacherInfo.school">{{ teacherInfo.school }}</div>
            </div>
            <div class="row">
              <div class="key">教学岗位</div>
              <div class="val" :title="teacherInfo.role_type + '/' + teacherInfo.current_role">{{ teacherInfo.role_type }}/{{ teacherInfo.current_role }}</div>
            </div>
            <div class="row">
              <div class="key">教学学科</div>
              <div class="val" :title="teacherInfo.p_subject + '/' + teacherInfo.subject">{{ teacherInfo.p_subject }}/{{ teacherInfo.subject }}</div>
            </div>
            <div class="row">
              <div class="key">任职情况</div>
              <div class="val" :title="teacherInfo.employment">{{ teacherInfo.employment }}</div>
            </div>
            <div class="row">
              <div class="key">政治面貌</div>
              <div class="val" :title="teacherInfo.political_outlook">{{ teacherInfo.political_outlook }}</div>
            </div>
            <div class="row">
              <div class="key">是否为班主任</div>
              <div class="val" :title="teacherInfo.class === 1 ? '是' : '否'">{{ teacherInfo.class === 1 ? '是' : '否' }}</div>
            </div>
            <div class="row">
              <div class="key">民族</div>
              <div class="val" :title="teacherInfo.nation_text">{{ teacherInfo.nation_text }}</div>
            </div>
            <div class="row">
              <div class="key">年龄</div>
              <div class="val" :title="teacherInfo.age">{{ teacherInfo.age }}</div>
            </div>
            <div class="row">
              <div class="key">教龄</div>
              <div class="val" :title="teacherInfo.teaching_experience">{{ teacherInfo.teaching_experience }}</div>
            </div>
            <div class="row">
              <div class="key">入职时间</div>
              <div class="val" :title="teacherInfo.entry_time">{{ teacherInfo.entry_time }}</div>
            </div>
            <div class="row">
              <div class="key">出生日期</div>
              <div class="val" :title="teacherInfo.birthday">{{ teacherInfo.birthday }}</div>
            </div>
            <div class="row">
              <div class="key">联系方式</div>
              <div class="val" :title="teacherInfo.mobile">{{ teacherInfo.mobile }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="credentials">
        <div class="credentials-item" style="width: 460rem;height: 220rem;background: #FFFFFF;border-radius: 8rem">
          <div style="display: flex;align-items: center;margin-bottom: 24rem">
            <el-image :src="zy" style="width: 24rem; height: 24rem"></el-image>
            <div style="font-weight: 600;font-size: 24rem;color: #1E3AA2;flex: 1;margin-left: 14rem">专业及院校</div>
          </div>
          <div style="margin-top: 20rem;display: grid;grid-template-columns: 1fr 1fr;gap: 20rem;">
            <div style="display: flex">
              <span class="credentials-item-key credentials-item-key-left">最高学历</span>
              <span class="credentials-item-val" :title="teacherInfo.education_text">{{ teacherInfo.education_text }}</span>
            </div>
            <div style="display: flex">
              <span class="credentials-item-key  credentials-item-key-right">是否师范专业</span>
              <span class="credentials-item-val" :title="teacherInfo.is_normal_text">{{ teacherInfo.is_normal_text }}</span>
            </div>
            <div style="display: flex">
              <span class="credentials-item-key credentials-item-key-left">毕业院校</span>
              <span class="credentials-item-val" :title="teacherInfo.graduated_from">{{ teacherInfo.graduated_from }}</span>
            </div>
            <div style="display: flex">
              <span class="credentials-item-key credentials-item-key-right">所学专业</span>
              <span class="credentials-item-val" :title="teacherInfo.major">{{ teacherInfo.major }}</span>
            </div>
          </div>
        </div>
        <div class="credentials-item" style="width: 460rem;height: 160rem;background: #FFFFFF;border-radius: 8rem">
          <div style="display: flex;align-items: center;margin-bottom: 24rem">
            <el-image :src="zc" style="width: 24rem; height: 24rem"></el-image>
            <div style="font-weight: 600;font-size: 24rem;color: #1E3AA2;flex: 1;margin-left: 14rem">职称及证书</div>
          </div>
          <div style="margin-top: 20rem;display: grid;grid-template-columns: 1fr 1fr;gap: 24rem;gap: 30rem">
            <div style="display: flex">
              <span class="credentials-item-key  credentials-item-key-right">是否有资格证</span>
              <span class="credentials-item-val" :title="teacherInfo.teacher_certificate_text">{{ teacherInfo.teacher_certificate_text }}</span>
            </div>
            <div style="display: flex">
              <span class="credentials-item-key credentials-item-key-right">教师职称</span>
              <span class="credentials-item-val" :title="teacherInfo.teacher_title">{{ teacherInfo.teacher_title }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="display: flex;justify-content: space-between;margin-top: 24rem">
      <div class="echarts-radar-box">
        <div style="display: flex;align-items: center">
          <el-image :src="czpg" style="width: 24rem; height: 24rem"></el-image>
          <div style="font-weight: 600;font-size: 24rem;color: #1E3AA2;flex: 1;margin-left: 14rem">{{ new Date().getMonth() + 1 }}月成长评估</div>
        </div>
        <div v-if="!Array.isArray(recordData.dimensional_graph)">
          <div class="echarts-radar" style="flex: 1;display: flex">
            <div ref="chartRef" class="chart"></div>

            <div class="score-list">
              <div v-for="(score, key) in scores" :key="key" class="score-item" style="font-size: 12rem">
                <span>{{ key }}</span>
                <span>{{ score }}</span>
              </div>
              <div class="score-item find">
                <span>最终得分</span>
                <span>{{ recordData.dimensional_graph.final }}</span>
              </div>
            </div>
          </div>
          <div style="font-weight: 400;font-size: 14rem;color: #3C3C3C;display: flex;">等级：
            <span style="background: #FEF0D7;color: #F3A726;border-radius: 3rem;padding-right: 4rem;line-height: 20rem;font-size: 12rem">
            <span style="width: 20rem;display: inline-block;text-align: center;line-height: 20rem;height: 20rem;background: #FCB438;color: #FFF;border-radius: 3rem;">{{ recordData.dimensional_graph.level }}</span>
            {{ recordData.dimensional_graph.describe }}
          </span>
          </div>
        </div>
        <div v-else class="t-result" style="margin-top: 20rem">
          <t-result text="暂无数据" type="empty"/>
        </div>
      </div>

      <div class="history-evaluation-record">
        <div style="display: flex;align-items: center">
          <el-image :src="ls" style="width: 24rem; height: 24rem"></el-image>
          <div style="font-weight: 600;font-size: 24rem;color: #1E3AA2;flex: 1;margin-left: 14rem">历史评估记录</div>
          <el-date-picker v-model="value1" :picker-options="pickerOptions" placeholder="选择日期" type="year" value-format="yyyy" @change="changeYear"/>
        </div>
        <el-table :data="recordData.record" :header-cell-style="{background:'#AAC4FF',color:'#1E3AA2',fontWeight: 400,fontSize: '14rem',textAlign:'center'}" height="298rem" size="small" style="margin-top: 20rem">
          <el-table-column v-for="i in tableConfig" :key="i.prop" :label="i.label" :prop="i.prop" align="center">
            <template v-if="i.prop === 'compared'" v-slot="{row}">
              <div style="display: flex;align-items: center;justify-content: center">
                <el-image v-if="Number(row.compared)>0||Number(row.compared)<0" :src="Number(row.compared) > 0 ? up : Number(row.compared) < 0 ?  down : ''" style="width: 20rem; height: 20rem"></el-image>
                <span style="font-size: 12rem;color: #3C3C3C;margin-left: 8rem">{{ Number(row.compared) == 0 ? '无变化' : format(row.compared) }}</span>
              </div>
            </template>
          </el-table-column>
          <template slot='empty'>
            <t-result imgStyle="width: 200rem !important;" text="暂无数据" type='empty'></t-result>
          </template>
        </el-table>
      </div>

      <div class="personal-profile">
        <div style="background: #FFF;border-radius: 8rem;padding: 24rem">
          <div style="display: flex;align-items: center">
            <el-image :src="gr" style="width: 24rem; height: 24rem"></el-image>
            <div style="font-weight: 600;font-size: 24rem;color: #1E3AA2;flex: 1;margin-left: 14rem">个人简介</div>
          </div>
          <div style="display: flex;flex-wrap: wrap">
            <el-tag v-for="(item, index) in teacherInfo.tags" :key="index" :type="getTagType(index)" style="margin-right: 12rem;margin-top: 16rem">
              {{ item }}
            </el-tag>
          </div>
          <div style="margin-top: 12rem;max-height: 110rem;font-weight: 400;display: -webkit-box;  -webkit-line-clamp: 5; line-clamp: 5; -webkit-box-orient: vertical;font-size: 16rem;overflow: hidden;  text-overflow: ellipsis;color: #3C3C3C;">
            {{ teacherInfo.summary }}
          </div>
          <t-result v-if="teacherInfo?.tags?.length===0 && teacherInfo.summary===''" imgStyle="height:161rem" text="暂无数据" type="empty"></t-result>
        </div>

        <div style="height: 80rem;background: linear-gradient( 180deg, #C9DDFD 0%, #7AADF9 100%);border-radius: 8rem;display: flex;align-items: center;justify-content: space-between;padding: 0 24rem;margin-top: 30rem">
          <div style="width: 194rem;height: 32rem;background: #E6F0FF;border-radius: 2rem 2rem 2rem 2rem;display: flex;align-items: center;padding: 0 12rem;cursor: pointer" @click="dialogVisible=true">
            <el-image :src="jxb"/>
            <div style="font-weight: 400;font-size: 14rem;color: #080C12;margin-left: 10rem">当前教学班</div>
          </div>

          <router-link :to="{path:'./history',query:{id}}" style="width: 194rem;height: 32rem;background: #E6F0FF;border-radius: 2rem 2rem 2rem 2rem;display: flex;align-items: center;padding: 0 12rem;cursor: pointer">
            <el-image :src="lsfb"/>
            <div style="font-weight: 400;font-size: 14rem;color: #080C12;margin-left: 10rem">
              历史分班记录
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <el-button icon="el-icon-arrow-left" plain style="margin-top: 40rem;" type="primary" @click="$router.back();"> 返回</el-button>

    <el-dialog :visible.sync="dialogVisible" title="当前教学班" width="30%">
      <el-table :data="tableData2" :header-cell-style="{background:'#AAC4FF',color:'#1E3AA2',fontWeight: 400,fontSize: '14rem',textAlign:'center'}" height="298rem" size="small" style="margin-top: 20rem">
        <el-table-column v-for="i in tableConfig2" :key="i.prop" :label="i.label" :prop="i.prop" :type="i.type" align="center"></el-table-column>
        <template slot='empty'>
          <t-result imgStyle="width: 200rem !important;" text="暂无数据" type='empty'></t-result>
        </template>
      </el-table>
      <div slot="footer" class="dialog-footer" style="display: flex;justify-content: center">
        <el-button type="primary" @click="dialogVisible = false">我已知晓</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Card from "@/components/Card.vue";
import img_ from "@/assets/img/photo_boy.png"
import jcxx from "./img/jcxx.svg";
import zy from "./img/zy.svg";
import zc from "./img/zc.svg";
import ls from "./img/ls.svg";
import gr from "./img/gr.svg";
import jxb from "./img/jxb.svg";
import lsfb from "./img/lsfb.svg";
import czpg from "../teacher-manager/img/czpg.svg";
import up from './img/up.svg'
import down from './img/donw.svg'

import * as echarts from "echarts";
import TResult from "@/components/Result.vue";

const svgReq = require.context('./img', false, /\.svg$/)
const svgMap = svgReq.keys().reduce((map, key) => {
  const mod = svgReq(key)
  const name = key.replace('./', '').replace('.svg', '')
  map[name] = mod && mod.default ? mod.default : mod
  return map
}, {})

export default {
  _config: {"route": {"path": "details", "meta": {"title": "查看", "style": 0}}},
  data() {
    return {
      img_: img_,
      jcxx: jcxx,
      zy: zy,
      zc: zc,
      ls: ls,
      gr: gr,
      jxb: jxb,
      lsfb: lsfb,
      czpg: czpg,
      up: up,
      down: down,
      xjList: Array.from({length: 7}, (_, i) => svgMap[String(i)]),
      value1: String(new Date().getFullYear()),
      pickerOptions: {
        disabledDate: (time) => {
          const currentYear = new Date().getFullYear();
          return time.getFullYear() > currentYear;
        }
      },
      // 表格配置
      tableConfig: [
        {
          prop: "month",
          label: "月份",
          width: "80rem",
        },
        {
          prop: "level",
          label: "等级"
        },
        {
          prop: "final",
          label: "最终得分"
        },
        {
          prop: "compared",
          label: "相较于上月"
        },
      ],
      teacherInfo: {},
      // 表格中的数据
      tableData: [],
      // 当前教学班
      tableData2: [],
      tableConfig2: [
        {
          type: "index",
          label: "序号",
        },
        {
          prop: "class_name",
          label: "班级"
        },
        {
          prop: "grade_name",
          label: "年级"
        },
        {
          prop: "class_type",
          label: "班级类型"
        },
        {
          prop: "teacher_type",
          label: "教师类型"
        },
        {
          prop: "subject",
          label: "教学科目"
        }
      ],
      id: null,
      dialogVisible: false,
      scores: {},
      recordData: {
        dimensional_graph: [],
        record: []
      }
    }
  },
  computed: {},
  components: {
    TResult,
    card: Card
  },
  methods: {
    format(val) {
      const num = Number(val)
      if (!isNaN(num)) {
        return Math.abs(num).toString()
      } else {
        return val
      }
    },
    getTagType(index) {
      const types = ['success', 'info', 'warning', 'danger']
      return types[index % types.length]
    },
    resizeChart() {
      if (this.chart) {
        this.chart.resize()
      }
    },
    initOrUpdateChart(scoreMap, values) {
      // 如果没有维度图数据（数组表示无数据），销毁已存在图表
      if (Array.isArray(this.recordData?.dimensional_graph)) {
        if (this.chart) {
          this.chart.dispose()
          this.chart = null
          window.removeEventListener('resize', this.resizeChart)
        }
        return
      }

      this.$nextTick(() => {
        const el = this.$refs.chartRef
        if (!el) return

        if (!this.chart) {
          this.chart = echarts.init(el)
          const option = {
            radar: {
              indicator: [
                {name: "工作态度", max: 100},
                {name: "备课反思", max: 100},
                {name: "教学能力", max: 100},
                {name: "学科辅导", max: 100},
                {name: "学科素养", max: 100},
                {name: "育人能力", max: 100}
              ],
              radius: '60%',
              splitNumber: 4,
              axisLine: {lineStyle: {color: '#D7E0F0', type: [5, 10]}},
              splitLine: {lineStyle: {color: ['#D7E0F0'], width: 1, type: [5, 10], cap: 'square'}},
              splitArea: {show: false},
              name: {
                formatter: function (dimName) {
                  return `{title|${dimName}}\n{score|${scoreMap[dimName] ?? 0}分}`
                },
                rich: {
                  title: {color: '#555555', align: 'center', fontSize: 12, margin: 3},
                  score: {color: '#224CB9', align: 'center', fontSize: 12}
                }
              }
            },
            series: [
              {
                type: 'radar',
                data: [{value: values, name: '综合评分'}],
                areaStyle: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{offset: 0, color: '#568FFE'}, {offset: 1, color: '#326BFF'}])
                },
                lineStyle: {color: '#346FFF'},
                itemStyle: {color: '#346FFF'}
              }
            ]
          }
          this.chart.setOption(option)
          window.addEventListener('resize', this.resizeChart)
        } else {
          // 更新配置
          this.chart.setOption({
            radar: {
              name: {
                formatter: function (dimName) {
                  return `{title|${dimName}}\n{score|${scoreMap[dimName] ?? 0}分}`
                },
                rich: {
                  title: {color: '#555555', align: 'center', fontSize: 12, margin: 3},
                  score: {color: '#224CB9', align: 'center', fontSize: 12}
                }
              }
            },
            series: [{data: [{value: values, name: '综合评分'}]}]
          })
        }
      })
    },
    getData() {
      this.$api2.get("api/teacher/account/teacher-details", {
        params: {
          id: this.id
        }
      }).then(res => {
        let {data} = res.data;
        this.teacherInfo = data;
      })
      this.$_axios.get("/teacher/class", {params: {id: this.id}}).then(res => {
        let {data} = res.data;
        this.tableData = data;
      })
      this.$_axios2.get("/api/common/public/current-class", {params: {teacher_id: this.id}}).then(res => {
        let {data: {data}} = res;
        this.tableData2 = data;
      })
    },
    getRecord() {
      this.$_axios2.get("api/teacher/evaluate/get-record", {params: {account_id: this.$route.query.id, year: this.value1}}).then(res => {
        this.recordData = res.data.data;
        const g = this.recordData?.dimensional_graph || {};
        // 更新侧边分数列表
        this.scores = {
          "工作态度": Number(g.work_attitude) || 0,
          "备课反思": Number(g.lesson_preparation) || 0,
          "学科辅导": Number(g.discipline) || 0,
          "教学能力": Number(g.teaching) || 0,
          "学科素养": Number(g.subject_literacy) || 0,
          "育人能力": Number(g.educate) || 0
        };
        // 更新雷达图数据，顺序需与 indicator 对齐
        const values = [
          this.scores["工作态度"],
          this.scores["备课反思"],
          this.scores["教学能力"],
          this.scores["学科辅导"],
          this.scores["学科素养"],
          this.scores["育人能力"]
        ];
        const scoreMap = {
          "工作态度": this.scores["工作态度"],
          "备课反思": this.scores["备课反思"],
          "教学能力": this.scores["教学能力"],
          "学科辅导": this.scores["学科辅导"],
          "学科素养": this.scores["学科素养"],
          "育人能力": this.scores["育人能力"]
        };
        this.initOrUpdateChart(scoreMap, values)
      })
    },
    changeYear() {
      this.getRecord()
    }
  },
  mounted() {
    this.id = this.$route.query.id;
    this.getData()
    this.getRecord()
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose()
      this.chart = null
    }
    window.removeEventListener('resize', this.resizeChart)
  }
}
</script>

<style lang="scss" scoped>
.router-view {
  background: #f7f7f7 !important;
  padding-right: 24rem;
}

.teacher-info {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.base-info {
  width: 1132rem;
  height: 404rem;
  background: #FFFFFF;
  border-radius: 8rem;
  padding: 24rem;

  .avatar {
    height: 100rem;
    margin-left: 16rem;
    display: flex;
    align-items: center;
  }

  .info {
    flex: 1;
    font-size: 14rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-left: 160rem;
    margin-top: 18rem;

    .name {
      margin-top: 20rem;
      //margin-bottom: 40rem;
    }

    .vitae {
      display: grid;
      grid-template-columns: repeat(3, 33.33333333%);
      grid-row-gap: 20rem;

      .row {
        line-height: 20rem;
        display: flex;

        .key {
          width: 88rem;
          margin-right: 20rem;
          color: #888888;
        }

        .val {
          color: #3C3C3C;
        }
      }
    }
  }
}

.credentials {
  width: 460rem;
  height: 404rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.credentials-item {
  padding: 24rem;
}

.credentials-item-key {
  color: #888888;
  display: inline-block;
}

.credentials-item-key-left {
  width: 84rem;
}

.credentials-item-key-right {
  width: 116rem;
}

.credentials-item-val {
  color: #3C3C3C;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 90rem;
  display: block;
}

.echarts-radar-box {
  width: 566rem;
  height: 410rem;
  background: #FFFFFF;
  border-radius: 8rem;
  padding: 24rem;
  display: flex;
  flex-direction: column;
}

.chart {
  width: 320rem;
  height: 306rem;
}

.score-list {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  font-weight: 400;
  font-size: 13rem;
  color: #555555;
  padding: 20rem 0;
}

.history-evaluation-record {
  width: 542rem;
  height: 410rem;
  background: #FFFFFF;
  border-radius: 8rem;
  padding: 24rem;
}

.personal-profile {
  width: 460rem;
  height: 410rem;
  border-radius: 8rem;
  display: flex;
  flex-direction: column;
}


::v-deep .el-table thead tr th.is-leaf {
  border: 0 solid #EBEEF5;
  border-right: none;
}

::v-deep .el-table {
  border: 0;

  th, tr, td {
    border: 0;
  }

  &::before {
    height: 0;
  }

  &::after {
    width: 0;
  }

  .el-table__fixed:before {
    height: 0;
  }

}

::v-deep .el-table, .el-table__expanded-cell {
  background-color: #FFF;
  color: #3C3C3C;
}

::v-deep .el-table tr {
  background-color: #FFF !important;
}

::v-deep .el-form-item {
  margin: 0 5rem !important;
}


::v-deep .el-table tr {
  background-color: transparent !important;
}

::v-deep .el-table--striped {
  background: #FFF;
}

::v-deep .t_dialog .t_title_bottom {
  margin-left: 0 !important;
}

::v-deep .t_dialog .t_title_top {
  margin-left: 0 !important;
  margin-top: 0 !important;
}

::v-deep .t_dialog .t_title_bottom {
  display: none;
}

::v-deep .t_dialog .t_title_body {
  padding: 0 !important;
}

.t-result {
  padding: 0 !important;
}

.score-item {
  width: 150rem;
  display: flex;
  height: 26rem;

  span {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.score-item:last-child {
  background: #DDEAFF;
  border-radius: 3rem;
}

.find {
  color: #1C4EFD;
  font-weight: 600;
  font-size: 12px;
  font-style: normal;
  text-transform: none;
}
</style>
